<template>
  <div class="row">
    <div class="col-12 col-sm-6 d-flex flex-column mb-3">
      <span ref="geturl" @click="getUrl()"></span>
      <span class="unit-selector-label">CIDADE</span>

      <select class="unit-selector-select" v-model="locationSelected">
        <option :value="null" disabled="disabled">Selecione uma opção</option>
        <template v-for="(item, key) in locations">
          <option :value="item.id" :key="key">{{ item.name }}</option>
        </template>
      </select>
    </div>
    
    <div class="col-12 col-sm-6 d-flex flex-column unit-selector-step">
      <template v-if="disableUnitStep">
        <div class="unit-selector-blocker"></div>
      </template>

      <span class="unit-selector-label">UNIDADE</span>

      <select class="unit-selector-select" v-model="unitSelected" :disabled="disableUnitStep">
        <option :value="null" disabled="disabled">Selecione uma opção</option>
        <template v-for="(item, key) in unitList">
          <option :value="item.id" :key="key">{{ item.name }}</option>
        </template>
      </select>
    </div>
    <!--
    <div v-if="isMobile" class="col-md-12">
      <div class="mt-4 mb-4" v-if="unitSelected && locationSelected">
        <div class="row">
          
          
          <div class="col-md-3 col-sm-3 col-3" v-if="getDomainActive('https://racebootcamp.com.br')">
            <p class="text-center" style="padding: 5px">
              <a
                v-if="isHaveTag('race')"
                @click="urlFilter('https://racebootcamp.com.br/horarios')"
                style="text-decoration: none; color: black"
              >
                <span class="mr-2" v-html="logoSVG('race')"></span><br />
              </a>
              <a
                v-else
                href="https://racebootcamp.com.br/horarios"
                style="text-decoration: none; color: black"
              >
                <span class="mr-2" v-html="logoSVG('race')"></span><br />
              </a>
            </p>
          </div>

           
          <div class="col-md-3 col-sm-3 col-3" v-if="getDomainActive('https://jabhouse.com.br')">
            <p class="text-center" style="padding: 5px">
              <a
                v-if="isHaveTag('jab')"
                @click="urlFilter('https://jabhouse.com.br/horarios')"
                style="text-decoration: none; color: black"
              >
                <span class="mr-2" v-html="logoSVG('jab')"></span><br />
              </a>
              <a
                v-else
                href="https://jabhouse.com.br/horarios"
                style="text-decoration: none; color: black"
              >
                <span class="mr-2" v-html="logoSVG('jab')"></span><br />
              </a>
            </p>
          </div>

           
          <div class="col-md-3 col-sm-3 col-3" v-if="getDomainActive('https://vidyastudio.com.br')">
            <p class="text-center" style="padding: 5px">
              <a
                v-if="isHaveTag('vidya')"
                @click="urlFilter('https://vidyastudio.com.br/horarios')"
                style="text-decoration: none; color: black"
              >
                <span class="mr-2" v-html="logoSVG('vidya')"></span><br />
              </a>
              <a
                v-else
                href="https://vidyastudio.com.br/horarios"
                style="text-decoration: none; color: black"
              >
                <span class="mr-2" v-html="logoSVG('vidya')"></span><br />
              </a>
            </p>
          </div>

          
          <div class="col-md-3 col-sm-3 col-3" v-if="getDomainActive('https://tonusgym.com.br')">
            <p class="text-center" style="padding: 5px">
              <a
                v-if="isHaveTag('tonus')"
                @click="urlFilter('https://tonusgym.com.br/horarios')"
                style="text-decoration: none; color: black"
              >
                <span class="mr-2" v-html="logoSVG('tonus')"></span><br />
              </a>
              <a
                v-else
                href="https://tonusgym.com.br/horarios"
                style="text-decoration: none; color: black"
              >
                <span class="mr-2" v-html="logoSVG('tonus')"></span><br />
              </a>
            </p>
          </div>

        </div>
      </div>
    </div>
    -->
  </div>
</template>

<style lang="scss" scoped>
.unit-selector-hide {
  display: none;
}

.unit-selector-label {
  font-size: 14px;
  font-weight: bold;
  color: #000;
}

.unit-selector-select {
  border: 1px solid #000 !important;
}

.unit-selector-step {
  position: relative;
}

.unit-selector-blocker {
  height: 100%;
  width: 100%;
  opacity: 0.7;
  position: absolute;
  top: 0;
  background: rgba(245, 245, 245, 1);
  z-index: 50;
}
.inactive-brand-logo {
  opacity: 0.3;
  cursor: not-allowed;
}
</style>

<script>
import { isSmallTablet, isTablet, isPhone } from '../../functions/mq.js';
class Cache {
  static get key() {
    return 'unit-package-selector';
  }

  static set(data) {
    return window.localStorage.setItem(
      this.key,
      JSON.stringify({
        ...this.get(),
        ...data,
      })
    );
  }

  static get() {
    return JSON.parse(window.localStorage.getItem(this.key) || '{}');
  }

  static has() {
    return Boolean(this.get());
  }
}

export default {
  props: ['packageWidgetSelector'],

  data() {
    return {
      unitSelected: null,
      locationSelected: null,
      useCache: false,
      disableUnitStep: true,
      unitList: [],
      locations: [],
      tags: null,
      paramsUrl:null,
      key:1
    };
  },

  created() {
    this.hideCalendar();

    this.getLocations().then((locations) => {
      this.locations = locations;

      const { rememberSelection, unit, location } = Cache.get();

      this.useCache = rememberSelection === true;

      if (this.useCache) {
        if (location) {
          this.locationSelected = Number(location);
        }

        if (unit) {
          this.unitSelected = Number(unit);
        }
      }
    });
  },
  mounted() {
    if (window.location.search != '') {
      let url = window.location.search;

      let objURL = this.getUrlVars(url);

      if (!this.locationSelected && objURL.location) {
        this.locationSelected = objURL.location;
      }
      if (!this.unitSelected && objURL.units) {
        this.unitSelected = objURL.units;
      }
    }
  },
  watch: {
    useCache(value) {
      Cache.set({ rememberSelection: value });
    },
    locationSelected(value) {
      this.disableUnitStep = false;
      Cache.set({ location: value });
      this.hideCalendar();
      this.unitList = [];
      const url = new URL(document.location).searchParams;
      url.delete('unit_list');
      window.history.replaceState({}, undefined, `?${url.toString()}`);
      this.getunitList().then((results) => (this.unitList = results));
      //this.unitSelected = null;
    },
    unitSelected(value) {
      Cache.set({ unit: value });
      let mileseconds = (this.key==1)?2000:200;
      this.$refs.geturl.click();
      setTimeout(()=>{
        this.getTagsByIdUnit(value);
        this.loadCalendar();
        this.key++;
      }, mileseconds);
      
    },
    paramsUrl(value){
      if(('units' in value) && ('location' in value)){
        this.locationSelected = value.location;
        this.unitSelected = value.units;
      }
    }
  },

  computed: {
    packageWidgetEl() {
      return window.document.querySelector(this.packageWidgetSelector);
    },
    isMobile() {
      return isTablet() || isSmallTablet() || isPhone();
    },
  },

  methods: {
    getDomainActive(domain){
      if(document.location.origin === domain) return false;
      else return true;
    },
    urlFilter(siteUrl) {
      window.location.href = siteUrl + window.location.search;
    },
    isHaveTag(brand) {
      if (!this.tags) return false;
      return this.tags.filter((fill) => fill === brand).length;
    },
    getTagsByIdUnit(id) {
      setTimeout(()=>{
        let tag = this.unitList;

        //let tags = tag.filter((fill) => fill.id === id);
        tag.map(item=>{
          if(item.id == id) this.tags = item.tags;
        });
      });
      
    },
    getUrlVars(url) {
      var hash;
      var myJson = {};
      var hashes = url.slice(url.indexOf('?') + 1).split('&');
      for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        myJson[hash[0]] = hash[1];
      }
      this.paramsUrl = myJson;
      return myJson;
    },
    hideCalendar() {
      this.packageWidgetEl.classList.add('unit-selector-hide');
    },
    showCalendar() {
      this.packageWidgetEl.classList.remove('unit-selector-hide');
    },
    loadCalendar() {
      if (!this.unitSelected) {
        return;
      }
      /* 
        Quando os dados vem de preseleção o componente de pacotes não foi carregado ainda.
        Interval permite rodar o código apenas quando o componente existir.
      */
      const interval = window.setInterval(() => {
        const calendar = this.packageWidgetEl.querySelector('ae-weekly-calendar');
        if (!calendar) {
          return;
        }

        window.clearInterval(interval);
        this.showCalendar();
        calendar.isExternalFilters = true;
        calendar.config = {
          eventParams: {
            units: this.unitSelected,
            location: this.locationSelected,
            activity_list: 46
          },
        };
      }, 100);
    },
    getLocations() {
      return new Promise((resolve) => {
        const locations = [];

        const paginator = window.AngularEcommerce.ws.locations.getAll({
          params: {
            enabled: true,
            use_as_filter: true,
            tag:'spider'
          },
        });

        paginator.getAllPages((res) => {
          locations.push(...res.data.results);

          if (!paginator.hasNextPage()) {
            resolve(locations);
          }
        });
      });
    },
    getunitList() {
      return new Promise((resolve) => {
        const unitList = [];

        const paginator = window.AngularEcommerce.ws.units.getAll({
          params: {
            is_online: true,
            location_list: this.locationSelected,
            tag:'spiderkick'
          },
        });

        paginator.getAllPages((res) => {
          unitList.push(...res.data.results);

          if (!paginator.hasNextPage()) {
            resolve(unitList);
          }
        });
      });
    },
    logoSVG(brand) {
      if (brand == 'race') {
        return '<svg xmlns="http://www.w3.org/2000/svg" width="16.5" height="19.684" viewBox="0 0 16.5 19.684"> <g id="Grupo_7709" data-name="Grupo 7709" transform="translate(692.455 -1948.539)" opacity="1"> <path id="Caminho_3102" data-name="Caminho 3102" d="M-684.18,1968.223a8.25,8.25,0,0,1-8.258-8.224l-.018-8.736,8.235-2.724,8.247,2.69.018,8.736a8.251,8.251,0,0,1-8.224,8.258m-7.742-16.575.017,8.35a7.717,7.717,0,0,0,7.724,7.692,7.717,7.717,0,0,0,7.692-7.724l-.017-8.35-7.713-2.516Z" transform="translate(0 0)" fill="#000"/> <path id="Caminho_3103" data-name="Caminho 3103" d="M-669.669,1964.953l-7.17,2.372.016,7.964a7.186,7.186,0,0,0,4.677,6.711l1.493-3.907-2.2,0,1.98-4.083-2.578,0,3.138-6.921,4.441-.009-2.472,5.011,2.067,0-2.7,4.146,1.809,0-4.353,5.968a7.166,7.166,0,0,0,1.889.25,7.183,7.183,0,0,0,7.16-7.189l-.016-7.964Z" transform="translate(-14.549 -15.292)" fill="#000"/> </g></svg>';
      }
      if (brand == 'vidya') {
        return '<svg xmlns="http://www.w3.org/2000/svg" width="19.869" height="19.685" viewBox="0 0 19.869 19.685"> <g id="Grupo_7717" data-name="Grupo 7717" transform="translate(-320.513 -926.881)" opacity="1"> <g id="Grupo_7713" data-name="Grupo 7713" transform="translate(320.513 926.881)"> <g id="Grupo_7712" data-name="Grupo 7712" transform="translate(0 0)"> <g id="Grupo_7711" data-name="Grupo 7711"> <path id="Caminho_3107" data-name="Caminho 3107" d="M339.778,933.36a9.81,9.81,0,0,0-5.134-5.551,9.949,9.949,0,0,0-7.592-.329,9.83,9.83,0,0,0-5.6,5.086,9.691,9.691,0,0,0-.332,7.522,9.808,9.808,0,0,0,5.134,5.551,9.97,9.97,0,0,0,13.2-4.758,9.7,9.7,0,0,0,.332-7.522Zm-1.229,7.108a8.851,8.851,0,0,1-5.045,4.579,8.958,8.958,0,0,1-6.835-.3,8.831,8.831,0,0,1-4.622-5,8.724,8.724,0,0,1,.3-6.773,8.851,8.851,0,0,1,5.045-4.579,8.956,8.956,0,0,1,6.835.3,8.8,8.8,0,0,1,4.323,11.771Z" transform="translate(-320.513 -926.882)" fill="#000"/> </g> </g> </g> <g id="Grupo_7716" data-name="Grupo 7716" transform="translate(322.363 930.146)"> <g id="Grupo_7715" data-name="Grupo 7715" transform="translate(0)"> <g id="Grupo_7714" data-name="Grupo 7714"> <path id="Caminho_3108" data-name="Caminho 3108" d="M367.934,989.719a6.706,6.706,0,0,0-2.153-.744,6.04,6.04,0,0,0,.013-3.31l-.134-.52-.368.031a7.251,7.251,0,0,0-2.291.666,7.36,7.36,0,0,0-.888-1.414,8.209,8.209,0,0,0-1.5-1.474l-.248-.177-.26.16a7.83,7.83,0,0,0-1.563,1.36,6.855,6.855,0,0,0-1.084,1.621,7.258,7.258,0,0,0-2.368-.661l-.363-.025-.1.346a6.67,6.67,0,0,0,.011,3.387,6.846,6.846,0,0,0-2.173.746l-.275.162.06.312a5.686,5.686,0,0,0,3.037,3.911,4.863,4.863,0,0,0,1.923.383,6.692,6.692,0,0,0,2.984-.757,6.782,6.782,0,0,0,3,.764,4.853,4.853,0,0,0,1.922-.383,5.682,5.682,0,0,0,3.037-3.911l.06-.312Zm-.767.625a4.633,4.633,0,0,1-2.416,2.93,4.917,4.917,0,0,1-3.72-.158,8.075,8.075,0,0,0,4.405-3.273A6.154,6.154,0,0,1,367.167,990.345Zm-3.921-.265c.052-.142.1-.286.138-.431.035-.126.065-.256.092-.4a5.12,5.12,0,0,0,.1-.888,5.371,5.371,0,0,0-.24-1.671,6.8,6.8,0,0,1,1.651-.557,5.807,5.807,0,0,1-.154,2.839c-.026.081-.053.155-.079.222,0,0-.017.039-.049.1a3.582,3.582,0,0,1-.208.335,5.385,5.385,0,0,1-.648.76,7.315,7.315,0,0,1-1.253.975A6.211,6.211,0,0,0,363.246,990.08Zm-7.831-3.869a6.739,6.739,0,0,1,1.72.559,5.12,5.12,0,0,0-.1,2.514c.028.138.062.275.1.406.045.158.092.3.145.445a7.1,7.1,0,0,0,1.106,1.925l.011.014a5.424,5.424,0,0,1-1.6-1.205,6.7,6.7,0,0,1-.908-1.238c-.086-.15-.143-.265-.177-.337-.017-.036-.028-.059-.029-.062-.033-.084-.065-.173-.1-.264A5.877,5.877,0,0,1,355.416,986.211Zm.229,7.056a4.634,4.634,0,0,1-2.416-2.93,6.163,6.163,0,0,1,1.735-.5,7.461,7.461,0,0,0,1.145,1.627,6.155,6.155,0,0,0,2.881,1.789A4.7,4.7,0,0,1,355.645,993.267Zm4.6-.72-.047.036-.03.022c-.087-.074-.177-.155-.271-.242l-.028-.025a7.141,7.141,0,0,1-1.612-2.211,5.21,5.21,0,0,1-.2-.533,4.488,4.488,0,0,1-.219-1.453,4.378,4.378,0,0,1,.149-1.05c.027-.1.061-.208.1-.328s.08-.216.124-.316a5.884,5.884,0,0,1,1-1.538,7.438,7.438,0,0,1,1.114-1.024,7.336,7.336,0,0,1,1.918,2.492c.043.1.086.2.127.316s.075.217.108.329a4.479,4.479,0,0,1,.181,1.326,4.371,4.371,0,0,1-.188,1.18,4.64,4.64,0,0,1-.18.5,5.259,5.259,0,0,1-.422.787,6.56,6.56,0,0,1-.588.77l-.033.037-.012.013a7.463,7.463,0,0,1-.593.587l-.134.115C360.425,992.407,360.336,992.479,360.247,992.547Z" transform="translate(-352.187 -982.777)" fill="#000"/> </g> </g> </g> </g></svg> </g></svg>';
      }
      if (brand == 'jab') {
        return '<svg xmlns="http://www.w3.org/2000/svg" width="19.683" height="19.685" viewBox="0 0 19.683 19.685"> <path id="Caminho_3106" data-name="Caminho 3106" d="M366.376,686.027a5.043,5.043,0,0,0-1.815-3.49l-2.71-2.71a5.037,5.037,0,0,0-3.767-1.462,4.956,4.956,0,0,0-3.613,1.785,2.984,2.984,0,0,0-.683,2.072l.006.141-.132-.051a3.654,3.654,0,0,0-4.907,4.122l.469,2.347-2.365,2.365a.511.511,0,0,0,0,.723l6.027,6.027a.511.511,0,0,0,.723,0l2.418-2.418,1.214-.011a6.529,6.529,0,0,0,4.1-1.9l3.582-3.582A5,5,0,0,0,366.376,686.027Zm-13.2,10.808-5.256-5.256,1.931-1.931,5.256,5.256Zm7.447-3.987a5.608,5.608,0,0,1-4.33,1.615,1.9,1.9,0,0,0-.222,0l-.047.008-5.775-5.774-.492-2.464a2.632,2.632,0,0,1,4.441-2.377l1.616,1.616a1.3,1.3,0,1,1-1.836,1.836l-1.279-1.279a.511.511,0,1,0-.723.723l1.279,1.279a2.323,2.323,0,0,0,3.282,0l.065-.065,1.4,1.4a2.927,2.927,0,0,0,4.134,0,.511.511,0,0,0-.723-.723,1.9,1.9,0,0,1-2.689,0l-1.6-1.6.014-.051a2.33,2.33,0,0,0-.6-2.241l-1.048-1.048a2.162,2.162,0,0,1-.237-2.892,3.949,3.949,0,0,1,2.879-1.422,4.007,4.007,0,0,1,3,1.164l3.078,3.078a3.992,3.992,0,0,1,0,5.638Z" transform="translate(-346.711 -678.36)" fill="#000" opacity="1"/></svg>';
      }
      if (brand == 'tonus') {
        return '<svg xmlns="http://www.w3.org/2000/svg" width="12.92" height="16.128" viewBox="0 0 12.92 16.128"> <g id="Grupo_7710" data-name="Grupo 7710" transform="translate(-133.359 -390.02)" opacity="1"> <path id="Caminho_3104" data-name="Caminho 3104" d="M139.3,406.162h-5.943v-1.837h3.706V391.876h-3.7v-1.842H139.3Z" transform="translate(0 -0.013)" fill="#000"/> <path id="Caminho_3105" data-name="Caminho 3105" d="M265.227,391.843v12.464h3.71v1.839h-5.95V390.02h5.945v1.823Z" transform="translate(-122.659 0)" fill="#000"/> </g></svg>';
      }
    },
    getUrl(){
      let mileseconds = this.key == 1? 3000 : 500;
      setTimeout(()=>{
        
        let tag = this.unitList;
        let id = this.unitSelected;
        //let currentParamsJson =this.getUrlVars(window.location.href);
        //delete currentParamsJson.units
        //let currentParamsQueryString =this.jsonToQueryString(currentParamsJson);

        tag.map(item=>{
          if(item.id == id) this.tags = item.tags;
        });

        document.querySelector('#race_sso') ? document.querySelector('#race_sso').href = 'https://racebootcamp.com.br/horarios' : '';
        document.querySelector('#tonus_sso') ? document.querySelector('#tonus_sso').href = 'https://tonusgym.com.br/horarios' : '';
        document.querySelector('#vidya_sso') ? document.querySelector('#vidya_sso').href = 'https://vidyastudio.com.br/horarios' : '';
        document.querySelector('#jab_sso') ? document.querySelector('#jab_sso').href = 'https://jabhouse.com.br/horarios' : '' ;

        this.tags.map(item=>{
          if(item == 'race' && document.querySelector('#race_sso')) document.querySelector('#race_sso').href = 'https://racebootcamp.com.br/horarios'+window.location.search;
          if(item == 'tonus' && document.querySelector('#tonus_sso')) document.querySelector('#tonus_sso').href = 'https://tonusgym.com.br/horarios'+window.location.search;
          if(item == 'vidya' && document.querySelector('#vidya_sso')) document.querySelector('#vidya_sso').href = 'https://vidyastudio.com.br/horarios'+window.location.search;
          if(item == 'jab' && document.querySelector('#jab_sso')) document.querySelector('#jab_sso').href = 'https://jabhouse.com.br/horarios'+window.location.search;
        });

        
      },mileseconds);
    },
    jsonToQueryString(json) {
        return '?' + 
            Object.keys(json).map(function(key) {
                return encodeURIComponent(key) + '=' +
                    encodeURIComponent(json[key]);
            }).join('&');
    }
  },
};
</script>